import type { Klass, LexicalNode } from 'lexical';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { GapImageNode } from './GapImageNode';

/** 
 * The Lexical editor is made up "node" components. 
 * This defines the set of nodes we are using or may use in the editor
*/
const GapNodes = [
   HeadingNode,
   ListNode,
   ListItemNode,
   QuoteNode,
   TableNode,
   TableCellNode,
   TableRowNode,
   AutoLinkNode,
   LinkNode,
   HorizontalRuleNode,
   GapImageNode
];

export default GapNodes as Array<Klass<LexicalNode>>
